export default __webpack_public_path__ + "static/media/ic_deletedata.b8a1de81.svg";